import { Directive } from '@angular/core';

@Directive({
  selector: '[sbLink]',
  host: {
    class:
      'tw-text-blue-600 hover:tw-text-blue-500 tw-transition-colors tw-text-base tw-whitespace-nowrap tw-cursor-pointer',
  },
})
export class LinkDirective {}
